import { useEffect, useState } from "react";
import styled from "styled-components";

import Configuration from "./Configuration";
import Selection from "./Selection";
import Summary from "./Summary";
import Background from "../../../components/Background";

const STEPS = [
    Selection,
    Configuration,
    Summary,
];

const Styled = styled.div`
    align-items: flex-start;
    box-sizing: border-box;
    color: #fff;
    display: flex;
    flex-direction: column;
    font-family: var(--font-mono), monospace;
    gap: 32px;
    padding: 8vh max(64px, 8vw) 25vh;

    & > a {
        margin-top: 8px;
    }

    & > header {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        font-size: 1.6rem;
        gap: 16px;
        margin-bottom: 32px;

        & > * {
            flex: none;
        }
    }

    & > footer {
        align-self: stretch;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
`;

export default function New() {
    const [step, setStep] = useState(0);

    const Component = STEPS[step];

    const [parameterID, setParameterID] = useState(undefined);
    const [bimClassID, setBIMClassID] = useState(undefined);

    useEffect(
        () => {
            const search = new URLSearchParams(window.location.search);
            if (search.has("parameterID")) setParameterID(search.get("parameterID"));
            if (search.has("bimClassID")) setBIMClassID(search.get("bimClassID"));
        },
        [],
    );

    const [revitDefinition, setRevitDefinition] = useState(undefined);

    return (
        <Styled>
            <Background position="bottom right" text="revit parameter template" />
            <Component
                parameterID={ parameterID }
                setParameterID={ setParameterID }
                bimClassID={ bimClassID }
                setBIMClassID={ setBIMClassID }
                revitDefinition={ revitDefinition }
                setRevitDefinition={ setRevitDefinition }
                next={ () => setStep((a) => a + 1) }
                prev={ () => setStep((a) => a - 1) }
            />
        </Styled>
    );
}






